import React, { useContext } from 'react';

/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Page } from '../Components/Page';
import { styles } from '@tag/tag-components-react-v3';
import { darkModeContext } from '../darkModeContext';

export const ColoursPage = () => (
  <Page title="Colours">
    <h2>Primary</h2>
    <div
      css={css`
        display: flex;
        flex-wrap: wrap;
        margin-top: 15px;
      `}
    >
      <Colour name="access" hex={styles.colours.access} />
      <Colour name="coral" hex={styles.colours.coral} />
      <Colour name="sunflower" hex={styles.colours.sunflower} />
      <Colour name="viridiangreen" hex={styles.colours.viridiangreen} />
    </div>
    <h2>Secondary</h2>
    <div
      css={css`
        display: flex;
        flex-wrap: wrap;
        margin-top: 15px;
      `}
    >
      <Colour name="atoll" hex={styles.colours.atoll} />
      <Colour name="denim" hex={styles.colours.denim} />
      <Colour name="dolphinblue" hex={styles.colours.dolphinblue} />
      <Colour name="finn" hex={styles.colours.finn} />
      <Colour name="flax" hex={styles.colours.flax} />
      <Colour name="gulfstream" hex={styles.colours.gulfstream} />
      <Colour name="keppel" hex={styles.colours.keppel} />
      <Colour name="midnightblue" hex={styles.colours.midnightblue} />
      <Colour name="mojo" hex={styles.colours.mojo} />
      <Colour name="navy" hex={styles.colours.navy} />
      <Colour name="plum" hex={styles.colours.plum} />
      <Colour name="porcelain" hex={styles.colours.porcelain} />
      <Colour name="shiraz" hex={styles.colours.shiraz} />
      <Colour name="surf" hex={styles.colours.surf} />
      <Colour name="tango" hex={styles.colours.tango} />
    </div>
    <h2>Grey</h2>
    <div
      css={css`
        display: flex;
        flex-wrap: wrap;
        margin-top: 15px;
      `}
    >
      <Colour name="border" hex={styles.colours.border} />
      <Colour name="title" hex={styles.colours.text} />
    </div>
  </Page>
);

type ColourProps = {
  name: string;
  hex: string;
};
const Colour: React.FC<ColourProps> = ({ name, hex }) => {
  const docsDarkMode = useContext(darkModeContext);
  const docsDarkModeValue = docsDarkMode.value || false;
  return (
    <div
      css={css`
        border: ${docsDarkModeValue ? '1px solid #000' : `1px solid ${styles.colours.border}`};
        border-radius: 3px;
        margin: 0px 20px 20px 0px;
        background-color: ${docsDarkModeValue ? '#383838' : '#fff'};
      `}
    >
      <div
        css={css`
          background-color: ${hex};
          border-radius: 3px 3px 0px 0px;
          width: 160px;
          height: 30px;
        `}
      ></div>
      <div>
        <div
          css={css`
            padding: 8px 15px;
          `}
        >
          <strong>{name}</strong>
          <div>{hex}</div>
        </div>
      </div>
    </div>
  );
};
